import { render, staticRenderFns } from "./Pendding.vue?vue&type=template&id=45b9f550&scoped=true&"
import script from "./Pendding.vue?vue&type=script&lang=js&"
export * from "./Pendding.vue?vue&type=script&lang=js&"
import style0 from "./Pendding.vue?vue&type=style&index=0&id=45b9f550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9f550",
  null
  
)

export default component.exports